import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';

const styles = (theme) => ({
  root: {
    fontSize: theme.typography.h4.fontSize,
    fontWeight: theme.typography.fontWeightFacetBold,
  },
});

const TextButton = ({
  className,
  classes,
  children,
  ...rest
}) => {
  return (
    <RoundedButton
      className={classNames(classes.root, className)}
      {...rest}
      variant={'text'}
    >
      {children}
    </RoundedButton>
  );
};

TextButton.defaultProps = {
  className: '',
  color: 'primary',
  weight: 'bold',
};

TextButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  weight: PropTypes.string,
};

export default withStyles(styles)(TextButton);
